import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({

    appBarSpacer: {
        minHeight: '64px',
        background: 'white',
    },
    header: {
        background: '#ECF2FF',
        display: 'flex',
        alignItems: 'center',
        padding: "0 15px",
        height: '58px',
        "& h2": {
            padding: '0px 15px',
            // fontSize: '22px',
            // fontWeight: 600,
            // lineHeight: '28.8px',
            // color: '#2D4D95',
            fontFamily: 'Lato',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: window.isMobileView ? window.isMobile425 ? 14:18:24,
            lineHeight: '29px',
            color: '#2D4D95',
        }
    },
    boxContainer: {
        padding: '10px 20px',
  
    },
    formContaner: {
        padding: '10px 20px',
        "& input": {
            marginRight: '5px',
        }
    },

    whiteBox: {
        border: '1px solid #e1e1e1',
        padding: '10px',
        borderRadius: '10px',
        margin: '7px',
        background: 'white',
        "& h3": {
            fontSize: '20px',
            borderBottom: '1px solid #dedede',
            padding: '10px'
        }
    },

    ProfileDetails: {
        "& h3": {
            textAlign: 'center',
            border: 0,
        },
        "& p": {
            marginLeft: '20px',
            fontSize: '16px',
        }
    },

    footer: {
        flex: "0 1 40px",
        width: '100%',
        marginLeft: 'auto',
        paddingBottom: window.isIpadView ? '80px' : '',
    },
    footerRight: {
        float: "right",
    
        display: 'flex',

    },

    profileImg: {
        position: 'relative',
        width: 'fit-content',
        margin: 'auto',
    },
    EditICon: {
        width: '40px',
        padding: '9px',
        zIndex: 4,
        right: 0,
        bottom: 0,
        position: 'absolute',
        background: '#0049A3',
        borderRadius: '16px',
        cursor: 'pointer',
    },
    changeBtn: {
        fontSize: window.isMobileView ? window.isMobile425 ? '8px' : '10px' : '14px',
        fontWeight: 500,
        cursor: 'pointer',
        backgroundColor: '#0049A3',
        borderRadius: '6px',
        marginRight: '5px',
        padding: window.isMobileView ? window.isMobile425 ? '4px 8px' : '6px 12px' : '8px 16px',
        fontFamily: 'Lato',
        textTransform: 'capitalize',
        cursor: 'pointer',
        color: '#ffffff',
        textWrap: 'nowrap',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)',
        '&:hover': {
            color: '#ffffff',
            background: '#00B4E5',
        }
    },
    selectBaseInput: {
        width: '100%',
        display: 'flex',
        boxSizing: 'border-box',
        margin: '5px 0px 5px',
        backgroundColor: 'white',
        minHeight: '35.63px',
        padding: '0px 8px 0px 8px',
        height: '35.63px',
        opacity: '0.7',
        border: '1px solid #d9d9d9',
        borderRadius: '4px',



        "& .MuiInputBase-input": {
            padding: "0px 24px 0px 0px",
            minHeight: "35.63px",
            fontSize:window.isMobileView?  window.isMobile425 ? '8px':'10px':'14px',
            color: "#4A4A4A",
            '&:focus': {
                background: 'transparent',
                borderRadius: "4px",
                outline: 0,
            },
            "&:before": {
                borderBottom: 'none !important',
            },
        },
        "& .MuiInput-underline:before": {
            borderBottom: 'none'
        },

        "& .Mui-disabled": {
            backgroundColor: "#f3f3f3",
            color: "#4A4A4A"
        },
        "& input::-webkit-outer-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input::-webkit-inner-spin-button": {
            appearance: "none",
            margin: 0
        },
        "& input[type=number]": {
            appearance: "textfield"
        },
    },

}))